import type { LoginCommand, SessionResponse } from '@sirius/contracts';

import { request } from '../client';

/** Той самий Better Auth, що й у клієнта; роль перевіряє бекенд, guard лише читає її з /me. */
export const login = (command: LoginCommand): Promise<void> =>
	request<unknown>('/auth/sign-in/email', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ email: command.email, password: command.password, rememberMe: command.rememberMe }),
	}).then(() => undefined);

export const logout = (): Promise<void> =>
	request<unknown>('/auth/sign-out', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: '{}',
	}).then(() => undefined);

export const getSession = (): Promise<SessionResponse | null> => request<SessionResponse | null>('/me');
